/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isString } from 'lodash';

// Component
import ConditionPredicate from 'shared/ui/components/form-components/targeting/ConditionPredicate.vue';
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';

const __vue_script__ = {
    name: 'ConditionRule',

    components: { ConditionPredicate, DropdownMenu },

    props: {
        eventId: {
            type: String,
            default: null
        },

        defaultToText: {
            type: Boolean,
            default: false
        },

        fields: {
            type: Array,
            required: true
        },

        value: {
            type: Array,
            default: () => ([])
        },

        readOnly: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        /** @returns {boolean} */
        addingField() {
            return this.predicates.some(p => !p.name);
        },

        /** @returns {object[]} */
        availableFields() {
            const usedFields = this.predicates.map(p => p.name);
            return this.fields
                .filter(f => this.$services.metadata.TARGETING_SUPPORTED_KINDS.includes(f.kind || 'text') || (f.kind === 'external' && f.kind_options.single_doc) || this.defaultToText)
                .filter(f => !usedFields.includes(f.name));
        },

        /** @returns {boolean} */
        canAddFields() {
            return !this.readOnly && Boolean(this.availableFields.length) && this.predicates.every(p => p.hasOwnProperty('value'));
        },

        predicates: {
            get() {
                return this.value;
            },

            set(newValue) {
                if (newValue.every(p => p.hasOwnProperty('value'))) {
                    this.$emit('input', newValue);
                }
            }
        }
    },

    methods: {
        /**
         * Gets the field name for the given predicate
         *
         * @returns {string} the proper label for the field
         */
        getFieldLabel(field) {
            return isString(field.label) ? field.label : field.name;
        },

        /**
         * Given a predicate, this method finds the corresponding
         * metadata field.
         *
         * @param {object} predicate
         *
         * @returns {object} the corresponding field
         */
        getFieldForPredicate(predicate) {
            return this.fields.find(f => f.hasOwnProperty('name') && f.name === predicate.name) || {};
        },

        /**
         * Sets the field for the component
         *
         * @param {object} field the field to set
         */
        addField(field) {
            if (this.readOnly) {
                return;
            }
            this.$set(this.predicates, this.predicates.length - 1, { name: field.name });
        },

        /**
         * Adds a new empty predicate to be edited
         */
        addPredicate() {
            if (this.readOnly) {
                return;
            }

            if (!this.addingField && this.canAddFields) {
                this.$set(this.predicates, this.predicates.length, {});
            }
        },

        /**
         * Remove the specified predicate from the set
         *
         * @param {object} predicate the predicate to remove
         */
        removePredicate(predicate) {
            if (this.readOnly) {
                return;
            }

            this.predicates = this.predicates.filter(p => p.name !== predicate.name);
        },

        /**
         * Handler for when the user does not select any
         * field name
         */
        noSelection() {
            this.predicates = this.predicates.filter(p => p.name);
        },

        setValue(predicate, value) {
            this.$set(predicate, 'value', value);
            this.$emit('input', this.predicates);
        },

        onChange() {
            this.$emit('change', this.predicates);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "condition-rule" },
    [
      _vm._l(_vm.predicates, function (predicate, index) {
        return _c("condition-predicate", {
          attrs: {
            "event-id": _vm.eventId,
            field: _vm.getFieldForPredicate(predicate),
            predicate: predicate,
            "show-separator": index < _vm.predicates.length - 1,
            "can-add-predicate": _vm.canAddFields,
            "read-only": _vm.readOnly,
          },
          on: {
            change: _vm.onChange,
            "change-field": function ($event) {
              return _vm.$set(predicate, "name", null)
            },
            input: function (value) {
              return _vm.setValue(predicate, value)
            },
            add: _vm.addPredicate,
            remove: _vm.removePredicate,
          },
        })
      }),
      _vm.addingField
        ? _c(
            "dropdown-menu",
            {
              staticClass: "field-selector",
              attrs: { "start-open": true, "anchor-pos": "nw" },
              on: { away: _vm.noSelection },
              scopedSlots: _vm._u(
                [
                  {
                    key: "toggler",
                    fn: function (ref) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("targeting.conditions_editor.select_field")
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ],
                null,
                false,
                3465402794
              ),
            },
            [
              _c(
                "ul",
                _vm._l(_vm.availableFields, function (field) {
                  return _c("li", { key: field.name }, [
                    _c(
                      "a",
                      {
                        staticClass: "has-action",
                        on: {
                          click: function ($event) {
                            return _vm.addField(field)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.getFieldLabel(field)))]
                    ),
                  ])
                }),
                0
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/targeting/ConditionRule.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__